import React, {useEffect, useState} from 'react';
import CustomerOrderService from "../../../API/orders/orders/customer/CustomerOrderService";
import CustomerOrderTable from "../../../components/UI/table/orders/customer/order/CustomerOrderTable";
import {useLocation} from 'react-router-dom';
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildKitchenOrdersSectionPath,
    buildMyOrdersSectionPath,
    CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
} from "../../../utils/customerBreadcrumbLabels";
import Box from "@mui/material/Box";
import {Paper} from "@mui/material";
import ButtonSelectAction from "../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../components/UI/modal/ModalSelectAction";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";

const CustomerOrders = ({kitchenOrders = false}) => {
    const storageKey = kitchenOrders ? "customer/kitchen-orders" : "customer/orders";
    const [rowSelection, setRowSelection] = useState([]);
    const [open, setOpen] = useState(false)
    const location = useLocation();
    const createType = new URLSearchParams(location.search).get('create');
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([]);
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(storageKey, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[storageKey]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    useEffect(() => {
        getStartPageSize()
        const loadOrders = kitchenOrders
            ? CustomerOrderService.getCompositionCustomerOrders()
            : CustomerOrderService.getAllCustomerOrders();
        loadOrders.then(function (response) {
            let data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [kitchenOrders]);

    const modalActions = [
        {name: "Переместить в архив", type: "archive"},
    ]
    const handleSelectAction = () => {
        CustomerOrderService.sendToArchive({
            "ids": rowSelection
        })
            .then(function () {
                setData(prev => prev.filter(el => rowSelection.includes(el.id)))
                setTableOptions((prev) => ({...prev, totalElements: data.length - rowSelection.length}))
                setOpen(false)
                setRowSelection([])
                handleModalAlert("Перемещено в архив", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={CUSTOMER_ORDERS_SUBMENU_BREADCRUMB.name}
                path={kitchenOrders ? buildKitchenOrdersSectionPath() : buildMyOrdersSectionPath()}
            />
            <CustomerOrderTable
                compositionOrders={kitchenOrders}
                createType={createType}
                data={data}
                setData={setData}
                rowSelection={rowSelection}
                setRowSelection={setRowSelection}
                handleModalAlert={handleModalAlert}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
            />
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
            </Paper>}
            <ModalSelectAction
                open={open}
                reset={() => setOpen(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
            />
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </Box>
    );
};

export default CustomerOrders;
